module.exports = __webpack_public_path__ + "img/icon-star-half-yellow.6e97b0d7c6437a348b8e91282a8435f3.svg";